import api from 'services/api';
import IConfigurationData from 'models/accountConfig/configuration';
import { SATISFACTION_SURVEY_TYPE } from './useSatisfactionSurvey';

export interface ISatisfactionSurveyPayload {
  tipo: string;
  rating: number;
  comentarios?: string;
}

export async function fetchPendingSurveys(): Promise<string[]> {
  const { data } = await api.get<IConfigurationData>('/preferencia-usuario');

  return data.pesquisasPendentes ?? [];
}

export async function submitSatisfactionSurvey(payload: ISatisfactionSurveyPayload): Promise<void> {
  await api.post('/pesquisa-satisfacao', payload);
}
